export function getAuth(state) {
  return state.auth;
}
